import { format } from "date-fns";
import { Avatar, Box, Button, Link, Typography } from "@mui/material";

import bg from "../../../../assets/images/payment-link/bg.png";
import {
  AppStoreButtonIcon,
  BackButtonWhiteIcon,
  CategoryIcon,
  ExpiryDateIcon,
  PlayStoreButtonIcon,
} from "../../../../assets/icons/MUI/PaymentLinkIcons";

import { useNavigate } from "react-router-dom";

const CategoryLabel = () => {
  return (
    <Box
      component="span"
      sx={{
        borderRadius: "16px",
        border: "1px solid var(--Error-200, #FECDCA)",
        background: "var(--Error-50, #FEF3F2)",
        mixBlendMode: "multiply",
        color: "var(--Error-700, #B42318)",
        textAlign: "center",
        fontFamily: "Montserrat",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "18px",

        display: "flex",
        gap: "8px",
        alignItems: "center",
        width: "fit-content",
        padding: "2px 8px",
      }}
    >
      Failed
    </Box>
  );
};

const HeaderSection = () => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
    <CategoryLabel />
    <Typography
      sx={{
        color: "var(--Dark---1000, #111)",
        fontFamily: "Montserrat",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
      }}
    >
      Payment Failed
    </Typography>
  </Box>
);

// const MetaSection = ({ transactionId }: { transactionId: string }) => (
const MetaSection = () => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
    <Typography
      sx={{
        color: "var(--Gray-600, #475467)",
        fontFamily: "Montserrat",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
      }}
    >
      We couldn’t process your payment. Please check your payment details or try another method. If the issue persists,
      contact our support team for assistance.
    </Typography>
    {/* <Box sx={{ display: "flex", gap: "12px" }}>
      <Typography
        sx={{
          color: "var(--Gray-900, #101828)",
          fontFamily: "Montserrat",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "28px",
        }}
      >
        Transaction ID
      </Typography>
      <Typography
        sx={{
          color: "var(--Gray-900, #101828)",
          fontFamily: "Montserrat",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "28px",
        }}
      >
        {transactionId}
      </Typography>
    </Box> */}
  </Box>
);

const FooterSection = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "16px" }}>
      <Button startIcon={<BackButtonWhiteIcon />} variant="primary-xl" onClick={() => navigate("/")} fullWidth>
        Back to Goalngo
      </Button>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
        <Typography
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Download App
        </Typography>
        <Box sx={{ display: "flex", gap: "8px" }}>
          <Link
            sx={{
              background: "none !important",
              border: "none !important",
              padding: 0,
            }}
            href="https://apps.apple.com/eg/app/goalngo/id6443919098"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AppStoreButtonIcon />
          </Link>
          <Link
            sx={{
              background: "none !important",
              border: "none !important",
              padding: 0,
            }}
            href="https://play.google.com/store/apps/details?id=com.goalngo_tech.goalngo&hl=en&pli=1"
            target="_blank"
            rel="noopener noreferrer"
          >
            <PlayStoreButtonIcon />
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

// const PaymentSummary = ({ transactionId }: { transactionId: string }) => {
const PaymentSummary = () => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${bg})`,
        width: "50%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "312px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
        }}
      >
        <HeaderSection />
        {/* <MetaSection transactionId={transactionId} /> */}
        <MetaSection />

        <Box sx={{ borderBottom: "1px solid #D9D9D9", width: "100%" }} />

        <FooterSection />
      </Box>
    </Box>
  );
};

export default PaymentSummary;
